/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { GetUsersQueryResponse } from '../types/GetUsers.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getGetUsersUrl() {
  const res = { method: 'GET', url: `/users` as const };
  return res;
}

/**
 * @summary Get users
 * {@link /users}
 */
export async function getUsers(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetUsersQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getGetUsersUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
